/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Only_For_External_BookingsInputs */

const en_admin_resource_form_only_for_external_bookings = /** @type {(inputs: Admin_Resource_Form_Only_For_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currently only available for external bookings.`)
};

const de_admin_resource_form_only_for_external_bookings = /** @type {(inputs: Admin_Resource_Form_Only_For_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derzeit nur für externe Buchungen verfügbar.`)
};

const es_admin_resource_form_only_for_external_bookings = /** @type {(inputs: Admin_Resource_Form_Only_For_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualmente solo disponible para reservas externas.`)
};

const fr_admin_resource_form_only_for_external_bookings = /** @type {(inputs: Admin_Resource_Form_Only_For_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actuellement disponible uniquement pour les réservations externes.`)
};

/** @type {(inputs: Admin_Resource_Form_Only_For_External_BookingsInputs) => LocalizedString} */
const it_admin_resource_form_only_for_external_bookings = en_admin_resource_form_only_for_external_bookings;

/** @type {(inputs: Admin_Resource_Form_Only_For_External_BookingsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_only_for_external_bookings = en_admin_resource_form_only_for_external_bookings;

/** @type {(inputs: Admin_Resource_Form_Only_For_External_BookingsInputs) => LocalizedString} */
const pl_admin_resource_form_only_for_external_bookings = en_admin_resource_form_only_for_external_bookings;

/** @type {(inputs: Admin_Resource_Form_Only_For_External_BookingsInputs) => LocalizedString} */
const hu_admin_resource_form_only_for_external_bookings = en_admin_resource_form_only_for_external_bookings;

/** @type {(inputs: Admin_Resource_Form_Only_For_External_BookingsInputs) => LocalizedString} */
const ro_admin_resource_form_only_for_external_bookings = en_admin_resource_form_only_for_external_bookings;

/**
* | output |
* | --- |
* | "Currently only available for external bookings." |
*
* @param {Admin_Resource_Form_Only_For_External_BookingsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_only_for_external_bookings = /** @type {((inputs?: Admin_Resource_Form_Only_For_External_BookingsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Only_For_External_BookingsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_only_for_external_bookings(inputs)
	if (locale === "de") return de_admin_resource_form_only_for_external_bookings(inputs)
	if (locale === "es") return es_admin_resource_form_only_for_external_bookings(inputs)
	if (locale === "fr") return fr_admin_resource_form_only_for_external_bookings(inputs)
	if (locale === "it") return it_admin_resource_form_only_for_external_bookings(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_only_for_external_bookings(inputs)
	if (locale === "pl") return pl_admin_resource_form_only_for_external_bookings(inputs)
	if (locale === "hu") return hu_admin_resource_form_only_for_external_bookings(inputs)
	return ro_admin_resource_form_only_for_external_bookings(inputs)
});
export { admin_resource_form_only_for_external_bookings as "admin.resource_form.only_for_external_bookings" }